<template>
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="row">
            <div class="col-lg-8 mb-4 order-0">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <ProductListTableComponent :subscriptions="subscriptions" />
                            <hr class="my-4">
                            <BillingListTableComponent :transactions="transactions" />
                            <hr class="my-4">
                            <InvoiceListTableComponent :invoices="invoices" />
                            <hr class="my-4">
                            <PaymentListTableComponent :payments="payments" />
                        </div>

                    </div>

                </div>

            </div>
            <div class="col-lg-4 col-md-4 order-1">
                <div class="row">
                    <div class="col-lg-6 col-md-12 col-6 mb-4">
                        <div class="card">
                            <div class="card-body">
                                <div class="card-title d-flex align-items-start justify-content-between">
                                    <div class="avatar flex-shrink-0">
                                        <span class="avatar-initial rounded bg-label-success"><i class="bx bx-cog"></i></span>
                                    </div>
                                </div>
                                <span class="fw-semibold d-block mb-1">Services</span>
                                <h3 class="card-title mb-2">{{ subscriptions.length }}</h3>
                                <!-- <small class="text-success fw-semibold"><i class="bx bx-up-arrow-alt"></i> +72.80%</small> -->

                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-6 mb-4">
                        <div class="card">
                            <div class="card-body">
                                <div class="card-title d-flex align-items-start justify-content-between">
                                    <div class="avatar flex-shrink-0">
                                        <span class="avatar-initial rounded bg-label-info"><i class="bx bx-credit-card"></i></span>
                                    </div>
                                </div>
                                <span class="fw-semibold d-block mb-1">Billing</span>
                                <h3 class="card-title mb-2">{{ transactions.filter(item => item.type === 'invoice' && item.status === 'overdue').length }}</h3>
                                <!-- <small class="text-success fw-semibold"><i class="bx bx-up-arrow-alt"></i> +72.80%</small> -->

                            </div>
                        </div>

                    </div>
                    <div class="col-lg-6 col-md-12 col-6 mb-4">
                        <div class="card">
                            <div class="card-body">
                                <div class="card-title d-flex align-items-start justify-content-between">
                                    <div class="avatar flex-shrink-0">
                                        <span class="avatar-initial rounded bg-label-warning"><i class="bx bx-receipt"></i></span>
                                    </div>
                                </div>
                                <span class="fw-semibold d-block mb-1">Invoices</span>
                                <h3 class="card-title mb-2">{{ invoices.length }}</h3>
                                <!-- <small class="text-success fw-semibold"><i class="bx bx-up-arrow-alt"></i> +72.80%</small> -->

                            </div>
                        </div>

                    </div>
                    <div class="col-lg-6 col-md-12 col-6 mb-4">
                        <div class="card">
                            <div class="card-body">
                                <div class="card-title d-flex align-items-start justify-content-between">
                                    <div class="avatar flex-shrink-0">
                                        <span class="avatar-initial rounded bg-label-danger"><i class="bx bx-dollar"></i></span>
                                    </div>
                                </div>
                                <span class="fw-semibold d-block mb-1">Payment</span>
                                <h3 class="card-title mb-2">{{ payments.length }}</h3>
                                <!-- <small class="text-success fw-semibold"><i class="bx bx-up-arrow-alt"></i> +72.80%</small> -->

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    import axios from 'axios';
    import ProductListTableComponent from '../components/ProductListTable.vue';
    import PaymentListTableComponent from '../components/PaymentListTable.vue';
    import BillingListTableComponent from '../components/BillingListTable.vue';
    import InvoiceListTableComponent from '../components/InvoiceListTable.vue';
    export default {
        components: { 
            ProductListTableComponent, 
            PaymentListTableComponent, 
            BillingListTableComponent, 
            InvoiceListTableComponent
        },
        data() {
            return {
                profile: null,
                invoices: [],
                payments: [],
                subscriptions: [],
                transactions: [],
                loading: true,
                error: null,
                pollingInterval: null
            };
        },
        created() {
            this.fetchCustomerData();
        },
        mounted() {
            this.pollingInterval = setInterval(() => {
                this.fetchCustomerData();
            }, 10000);
        },
        beforeUnmount() {
            clearInterval(this.pollingInterval);
        },
        methods: {
            fetchCustomerData() {
                const customerId = localStorage.getItem('customerId');
                if(customerId != undefined){
                    axios.get('/api/zoho/customer-profile/' + customerId)
                    .then(response => {
                        let data = response.data;
                        this.profile = data.customer;
                        this.invoices = data.invoices;
                        this.payments = data.payments;
                        this.subscriptions = data.subscriptions;
                        this.transactions = data.transactions;
                    })
                    .catch(() => {
                        this.error = 'Failed to fetch profile data.';
                    })
                    .finally(() => {
                        this.loading = false;
                    });

                }
                
            },
        },
    };
</script>

<style scoped>
/* Add dashboard styles here */
</style>
